import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";

import { IoChevronForwardCircle } from "react-icons/io5";
import { IconContext } from "react-icons";
import { motion } from "framer-motion";

let easeing = [0.6, -0.05, 0.01, 0.99];

const btnGroup = {
  initial: {
    y: -60,
    opacity: 0,
    transition: { duration: 0.6, ease: easeing },
  },
  animate: {
    y: 0,
    opacity: 1,
    animation: {
      duration: 0.6,
      ease: easeing,
    },
  },
};

const LoginButton = ({ buttonText, buttonStyle, showIcon, closeDropdown }) => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const history = useHistory();

  const handleLogin = () => {
    loginWithRedirect()
      .then(() => {
        // Redirect to the desired URL after successful login
        history.push("/schedule");
      })
      .catch((error) => {
        // Handle login error if needed
        console.error("Login error:", error);
      });
  };

  return (
    !isAuthenticated && (
      <motion.div
        className={buttonStyle}
        variants={btnGroup}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          handleLogin(); // Use the handleLogin function
          if (closeDropdown) {
            closeDropdown();
          }
        }}
      >
        {buttonText}
        {showIcon && (
          <IconContext.Provider
            value={{
              color: "#14da8f",
              size: "25px",
            }}
          >
            <IoChevronForwardCircle />
          </IconContext.Provider>
        )}
      </motion.div>
    )
  );
};

export default LoginButton;
